import { Suspense, lazy } from 'react';
import type { ReactElement } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { LoadingScreen } from '../components/LoadingScreen';

const Home = lazy(() => import('../modules/Home'));
const About = lazy(() => import('../modules/About'));
const Projects = lazy(() => import('../modules/Projects'));
const Experience = lazy(() => import('../modules/Experience'));
const Education = lazy(() => import('../modules/Education'));
const Awards = lazy(() => import('../modules/Awards'));
const Contact = lazy(() => import('../modules/Contact'));
const NotFound = lazy(() => import('../modules/NotFound'));

const withSuspense = (element: ReactElement) => (
  <Suspense fallback={<LoadingScreen />}>{element}</Suspense>
);

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: withSuspense(<Home />) },
      { path: 'about', element: withSuspense(<About />) },
      { path: 'projects', element: withSuspense(<Projects />) },
      { path: 'experience', element: withSuspense(<Experience />) },
      { path: 'education', element: withSuspense(<Education />) },
      { path: 'awards', element: withSuspense(<Awards />) },
      { path: 'contact', element: withSuspense(<Contact />) },
      { path: '*', element: withSuspense(<NotFound />) }
    ]
  }
]);
